import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader {
  /**
   * Static JSON needs no session, so skip the HTTP interceptors: loading translations
   * must not attach a Bearer token, refresh the session or log the user out (the public
   * share page loads them for viewers who may hold someone's stale session).
   */
  #http = new HttpClient(inject(HttpBackend));

  getTranslation(lang: string): Observable<Translation> | Promise<Translation> {
    return this.#http.get<Translation>(`/i18n/${lang}.json`);
  }
}
